import * as React from 'react'

import { List } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { EmployeesSetting } from 'modules/attendance/hooks/useFetchEmployeesSettings'

import PolicyCard from './PolicyCard'

interface Props {
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  employeesSettings: EmployeesSetting[]
}

const TimeTrackingPolicySelectorModal = ({ setModalOpen, employeesSettings }: Props) => {
  return (
    <Modal
      title={i18n.t('time_tracking.settings.policy_selector_modal.title')}
      illustration="night"
      description={i18n.t('time_tracking.settings.policy_selector_modal.description')}
      onClose={() => setModalOpen(false)}
    >
      <List>
        {employeesSettings.map((employeesSetting) => (
          <List.Item key={employeesSetting.id}>
            <PolicyCard employeesSetting={employeesSetting} setModalOpen={setModalOpen} />
          </List.Item>
        ))}
      </List>
    </Modal>
  )
}

export default TimeTrackingPolicySelectorModal
